import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import "./style.scss";
import { motion } from "framer-motion";

const AnimatedChar = ({ char, delay }: any) => {
  return (
    <motion.span
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      style={{ display: 'inline-block' }}
    >
      {char === " " ? "\u00A0" : char}
    </motion.span>
  );
};

const AnimatedText = ({ text, firstDelay }: any) => {
  return (
    <span style={{ display: 'inline-block' }}>
      {text.split("").map((char: any, index: any) => (
        <AnimatedChar
          key={`${char}-${index}`}
          char={char}
          delay={firstDelay + index * 0.1}
        />
      ))}
    </span>
  );
};


const MainBanner: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  const loopInterval = 10000;
  const firstTimeDelay = 0;
  const wordsTop = [
    { text: "Launch,", firstDelay: 0 },
    { text: "Build,", firstDelay: 0.7 },
    { text: "and", firstDelay: 1.3 },
    { text: "Scale", firstDelay: 1.6 },
  ];

  const wordsCenter = [
    { text: "Web3", firstDelay: 2.1 },
    { text: "Projects", firstDelay: 2.5 },
    { text: "Seamlessly.", firstDelay: 3.3 },
  ];

  const wordsBottom = [
    { text: "Powered", firstDelay: 4.4 },
    { text: "by", firstDelay: 5.1 },
    { text: "$bscs", firstDelay: 5.3 },
  ];

  const [restart, setRestart] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    let interval: NodeJS.Timeout | undefined;

    const startAnimation = () => {
      timer = setTimeout(() => setRestart(true), firstTimeDelay * 1000);
    };

    startAnimation();

    return () => {
      clearTimeout(timer);
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (restart) {
      interval = setInterval(() => {
        setRestart(false);
        setTimeout(() => setRestart(true), 500);
      }, loopInterval);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [restart]);

  return (
    <div className="main-banner-layout">
      <div className="layout">
        <div className="inner-layout">
          <div className="main-banner">
            <video
              className="bg"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src="/new-banner.mp4" type="video/mp4" />
              {/* <source src="/main-banner-1.mp4" type="video/webm" /> */}
            </video>
            <div className="absolute">
              <div className="text-group">
                <h1>
                  {restart && (
                    <>
                      <AnimatedText
                        text={wordsTop[0].text}
                        firstDelay={wordsTop[0].firstDelay}
                      />{" "}
                      <AnimatedText
                        text={wordsTop[1].text}
                        firstDelay={wordsTop[1].firstDelay}
                      />{" "}
                      <AnimatedText
                        text={wordsTop[2].text}
                        firstDelay={wordsTop[2].firstDelay}
                      />{" "}
                      <AnimatedText
                        text={wordsTop[3].text}
                        firstDelay={wordsTop[3].firstDelay}
                      />
                    </>
                  )}
                </h1>
                <h1>
                  {restart && <>
                    <AnimatedText
                      text={wordsCenter[0].text}
                      firstDelay={wordsCenter[0].firstDelay}
                    />{" "}
                    <AnimatedText
                      text={wordsCenter[1].text}
                      firstDelay={wordsCenter[1].firstDelay}
                    />{" "}
                    <AnimatedText
                      text={wordsCenter[2].text}
                      firstDelay={wordsCenter[2].firstDelay}
                    />
                  </>}
                </h1>
                <h1 className="gradient">
                  {restart && <>
                    <AnimatedText
                      text={wordsBottom[0].text}
                      firstDelay={wordsBottom[0].firstDelay}
                    />{" "}
                    <AnimatedText
                      text={wordsBottom[1].text}
                      firstDelay={wordsBottom[1].firstDelay}
                    />{" "}
                    <AnimatedText
                      text={wordsBottom[2].text}
                      firstDelay={wordsBottom[2].firstDelay}
                    />
                  </>}
                </h1>
              </div>
              <div className="btn-group">
                <div onClick={() => scrollToSection("products")} className="access"><span>Learn More</span><img alt='' src="images/home/main-banner/right-1.svg" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBanner;
